module.exports = "/_next/static/images/Neopixels-88524d67aafae756884435d074e9b7b4.svg";